
import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import ChartIntraday from './ChartIntraday';
import { convertDateForIos } from '../../service/Util';

class Nasdaq extends Component {

	custom_sort(a, b) {
		return new Date(a.date).getTime() - new Date(b.date).getTime();
	}

	componentDidMount() {
		ApiService.getStockHistoricalPrice('^IXIC', '15min').then(result => {
			let noData = true;
			let startDate = new Date();
			let endDate = new Date();

			//Fix for IOS
			for (var i = 0; i < result.length; i++) {
				result[i].date = convertDateForIos(result[i].date);
			}

			while (noData) {
				// var startDate = new Date("2021-12-04");
				// var endDate = new Date("2021-12-04");
				// var startDate = new Date();
				// var endDate = new Date();	
				startDate.setHours(0, 0, 0, 0);
				endDate.setHours(0, 0, 0, 0);
				console.log('result', result, startDate, endDate);

				var resultProductData = result.filter(a => {
					var date = new Date(a.date);
					date.setHours(0, 0, 0, 0);
					return (date >= startDate && date <= endDate);
				});

				if (resultProductData !== undefined && resultProductData.length > 0) {
					noData = false;
					break;
				}
				startDate.setDate(startDate.getDate() - 1);
				endDate.setDate(endDate.getDate() - 1);
			}
			console.log('resultProductData', resultProductData);

			let filteredData = [];
			for (i = 0; i < resultProductData.length; i++) {
				resultProductData[i].date = new Date(resultProductData[i].date);
				filteredData.push(resultProductData[i]);
			}
			console.log('dow historical price', result, filteredData);
			filteredData.sort(this.custom_sort);
			console.log('dow historical price sorted', filteredData);
			this.setState({ data: filteredData })
		})
			.catch((error) => {
				console.log(error);
			});

	}
	render() {
		if (this.state == null) {
			return <div>Loading...</div>
		}
		if (this.state.data.length <= 0) {
			return <div>No Data</div>
		}
		return (
			<ChartIntraday type={'svg'} data={this.state.data} />
		)
	}
}

export default Nasdaq;
